const cover = document.querySelector('.cover')
const vinyl = document.querySelector('.vinyl')
const playerA = document.querySelector('#sidea')
const timeStamps = document.querySelectorAll('.time-travel')

const startPlayback = (player) => {
    vinyl.classList.remove('recover')
    vinyl.classList.add('uncover')
}

const stopPlayback = () => {
    vinyl.classList.add('recover')
    vinyl.classList.remove('uncover')
}

playerA.addEventListener('play', () => {
    startPlayback('playerA')
})

playerA.addEventListener('pause', () => {
    stopPlayback()
})

vinyl.addEventListener('animationend', (event) => {
    switch (event.animationName) {
        case 'uncover':
            vinyl.classList.remove('uncover')
            vinyl.classList.add('spin')
            break
    }
})

timeStamps.forEach((timeStamp) => {
    timeStamp.addEventListener('click', () => {
        const time = parseInt(timeStamp.dataset.timestamp)
        playerA.currentTime = time

        if (playerA.paused) {
            playerA.play()
        }
    })
})

function randomFlicker() {
    const els = document.querySelectorAll('.flicker-wrapper .layer')

    els.forEach((el) => {
        const flick = Math.random()
        if (flick < 0.1) {
            el.style.opacity = '0.3'
            el.style.textShadow = 'none'
        } else if (flick < 0.2) {
            el.style.opacity = '0.5'
            el.style.textShadow = '0 0 2px lightblue'
        } else {
            el.style.opacity = '0.7'
            el.style.textShadow = '0 0 10px lightblue'
        }
    })

    setTimeout(randomFlicker, Math.random() * 400)
}

function headlineFlicker() {
    const els = document.querySelectorAll('h2 .layer')

    els.forEach((el) => {
        const flick = Math.random()
        if (flick < 0.1) {
            el.style.opacity = '0.1'
            el.style.textShadow = 'none'
        } else if (flick < 0.2) {
            el.style.opacity = '0.25'
            // el.style.textShadow = '0 0 2px lightblue'
        } else {
            el.style.opacity = '1'
            // el.style.textShadow = '0 0 10px lightblue'
        }
    })

    setTimeout(headlineFlicker, Math.random() * 1800)
}

randomFlicker()
headlineFlicker()
